import { Box, Grid, MenuItem, TextField } from "@mui/material";
import CustomMde from "./CustomMde";
import { qualificationChoices } from "./dropDownData";
import { RequiredAsterisk } from "../../../components/professional/RequiredAsterisk";
import MultiSelect from "../../../components/common/MultiSelect";
import { convertStringToOptions } from "../../../utils/helpers";
const DescriptionStep = ({ data, onChange, errors, dropDownOptions }) => {
  const { qualificationChoices } = dropDownOptions;
  const handleMultiSelect = (event) => {
    const value = event.target.value;
    onChange(
      "minimum_qualifications",
      typeof value === "string" ? value.split(",") : value
    );
  };

  return (
    <Box component="form" noValidate>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12 }}>
          <CustomMde
            onChange={(val) => onChange("description", val)}
            value={data.description}
            error={errors.description}
            label="Job Description"
            required={true}
            placeholder="Describe the job..."
          />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <CustomMde
            onChange={(val) => onChange("responsibilities", val)}
            value={data.responsibilities}
            error={errors.responsibilities}
            label="Responsibilities"
            placeholder="Key responsibilities for this position"
            required={true}
          />
        </Grid>

        {/* Minimum Qualifications */}
        <Grid size={{ xs: 12 }}>
          <MultiSelect
                      id="minimum_qualifications"
                      label="Minimum Qualifications"
                      options={qualificationChoices}
                      value={convertStringToOptions(
                        data.minimum_qualifications,
                        qualificationChoices
                      )}
                      onChange={(value) => onChange("minimum_qualifications", value)}
                      limitTags={3}
                      error={!!errors.minimum_qualifications}
                      helperText={errors.minimum_qualifications}
                      isArr={true}
                    />
          {/* <TextField
            select
            fullWidth
            // SelectProps={{ multiple: true }}
            slotProps={{ select: { multiple: true } }}
            label="Minimum Qualifications"
            value={data.minimum_qualifications || []}
            onChange={handleMultiSelect}
            error={!!errors.minimum_qualifications}
            helperText={errors.minimum_qualifications}
          >
            {dropDownOptions.qualificationChoices.map((q) => (
              <MenuItem key={q.value} value={q.value}>
                {q.label}
              </MenuItem>
            ))}
          </TextField> */}
        </Grid>

        {/* <Grid size={{ xs: 12 }}>
          <TextField
            // type="number"
            fullWidth
            label={
              <span>
                Aircraft type <RequiredAsterisk />
              </span>
            }
            placeholder="Boieng 737"
            // slotProps={{ htmlInput: { min: 0 } }}
            value={data.aircraft_type}
            error={errors.aircraft_type}
            helperText={errors.aircraft_type}
            onChange={(e) => onChange("aircraft_type", e.target.value)}
          />
        </Grid> */}

        <Grid size={{ xs: 12 }}>
          <CustomMde
            label="Benefits"
            onChange={(val) => onChange("benefits", val)}
            placeholder="Benefits offered with this position"
            value={data.benefits}
            // required={true}
          />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <CustomMde
            label="Internal Notes"
            onChange={(val) => onChange("internal_notes", val)}
            // placeholder='Benefits offered with this position'
            value={data.internal_notes}
            // required={true}
            // rows={2}
          />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <CustomMde
            onChange={(val) => onChange("diversity_goals", val)}
            value={data.diversity_goals}
            // error={errors.responsibilities}
            label="Diversity Goals"
            placeholder="Optional field for inclusive hiring"
            required={false}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default DescriptionStep;
